/**
 * DBS Chevron hover
 */
jQuery(window).on( 'load',  function(){
	jQuery('#dbs-chev').on('click', function(){
		jQuery(this).toggleClass('hover');
	});
});
